import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
    // Mobile menu open/close karne ke liye state
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="bg-white shadow-md sticky top-0 z-50">
            <div className="flex items-center justify-between px-6 md:px-10 py-4">

                {/* Logo Area */}
                <div className="flex items-center">
                    {/* Mobile par logo thoda chhota (h-14) aur desktop par bada (md:h-20) dikhega */}
                    <Link to="/">
                        <img src="/logo.png" alt="LEV India Logo" className="h-14 md:h-20 w-auto object-contain" />
                    </Link>
                </div>

                {/* Desktop Links (md:flex se sirf badi screen par dikhega, mobile par hidden) */}
                <div className="hidden md:flex gap-8 font-bold text-gray-800 tracking-wide text-sm">
                    <Link to="/" className="hover:text-blue-900 transition">HOME</Link>
                    <Link to="/about" className="hover:text-blue-900 transition">ABOUT</Link>
                    <Link to="/products" className="hover:text-blue-900 transition">PRODUCTS</Link>
                    <Link to="/gallery" className="hover:text-blue-900 transition">GALLERY</Link>
                    <Link to="/contact" className="hover:text-blue-900 transition">CONTACT</Link>
                </div>

                {/* Desktop Enquiry Button */}
                <div className="hidden md:block">
                    <Link to="/enquiry">
                        <button className="px-8 py-3 text-white bg-blue-900 rounded-full font-bold hover:bg-blue-800 transition duration-300 shadow-lg">
                            ENQUIRY
                        </button>
                    </Link>
                </div>

                {/* Hamburger Button (Sirf mobile par dikhega: md:hidden) */}
                <div className="md:hidden flex items-center">
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="text-gray-800 focus:outline-none"
                    >
                        {/* Icon change hoga open/close ke hisaab se */}
                        <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            {isOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile Menu Dropdown (Sirf tabhi dikhega jab isOpen true hoga) */}
            {isOpen && (
                <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 space-y-3 font-semibold text-gray-700 shadow-inner">
                    <Link
                        to="/"
                        onClick={() => setIsOpen(false)}
                        className="block hover:text-blue-900 transition py-2 border-b border-gray-50"
                    >
                        HOME
                    </Link>
                    <Link
                        to="/about"
                        onClick={() => setIsOpen(false)}
                        className="block hover:text-blue-900 transition py-2 border-b border-gray-50"
                    >
                        ABOUT
                    </Link>
                    <Link
                        to="/products"
                        onClick={() => setIsOpen(false)}
                        className="block hover:text-blue-900 transition py-2 border-b border-gray-50"
                    >
                        PRODUCTS ▾
                    </Link>
                    <Link
                        to="/gallery"
                        onClick={() => setIsOpen(false)}
                        className="block hover:text-blue-900 transition py-2 border-b border-gray-50"
                    >
                        GALLERY
                    </Link>
                    <Link
                        to="/media"
                        onClick={() => setIsOpen(false)}
                        className="block hover:text-blue-900 transition py-2 border-b border-gray-50"
                    >
                        MEDIA
                    </Link>
                    <Link
                        to="/contact"
                        onClick={() => setIsOpen(false)}
                        className="block hover:text-blue-900 transition py-2 border-b border-gray-50"
                    >
                        CONTACT
                    </Link>

                    {/* Mobile Enquiry Button (Link se wrap kiya gaya hai taaki click ho sake) */}
                    <Link to="/enquiry" onClick={() => setIsOpen(false)}>
                        <button className="w-full mt-4 px-6 py-3 text-white bg-blue-900 rounded-full font-bold hover:bg-blue-800 transition duration-300 shadow-md">
                            ENQUIRY
                        </button>
                    </Link>
                </div>
            )}
        </nav>
    );
};

export default Navbar;